module.exports = __webpack_public_path__ + "fonts/RenaultLife-Bold.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fonts/latin-basic/RenaultLife-Bold.svg
// module id = 350
// module chunks = 0